<template>
  <div class="counterField formField" :class="{isError, isRequired, isInline, isSmall, isDisabled: disabled}">
    <FormLabel v-bind="formLabelProps">
      <slot name="tooltip" />
    </FormLabel>
    <div class="conterField__Controls">
      <button type="button" @click="down" :disabled="disabled" :class="{'isDisable': modelValue <= minValue, isDisabled: disabled}">
        <Icon name="minus" />
      </button>
      <div class="counterField__Value">{{ modelValue }}</div>
      <button type="button" @click="up" :disabled="disabled" :class="{'isDisable': modelValue >= maxValue, isDisabled: disabled}">
        <Icon name="plus" />
      </button>
    </div>
    <FormError :errors="mergedErrors" className="counterField__Error" />
  </div>
</template>

<script setup>
  const emit = defineEmits(['update:modelValue']);
  const props = defineProps({
    ...useFormFieldProps(),
    modelValue: {
      type: Number,
      required: true,
      default: 1,
    },
    minValue: {
      type: [Number, String],
      default: 0,
    },
    maxValue: {
      type: [Number, String],
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  })

  const {
    isError,
    isDisabled,
    isRequired,
    isInline,
    hasValue,
    fieldValue,
    mergedErrors,
    uniqueID,
    formLabelProps,
    triggerValidate,
  } = useFormField(props, emit)

  defineExpose({
    triggerValidate,
  })

  const isSmall = computed(() => props.small)

  function down() {
    if (props.minValue && props.modelValue <= props.minValue) return;
    emit('update:modelValue', props.modelValue - 1)
  }

  function up() {
    if (props.maxValue && props.modelValue >= props.maxValue) return;
    emit('update:modelValue', props.modelValue + 1)
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/forms/_counterField.scss');
</style>